// Latin Intermediate Vocabulary - 50 unique items
// Each item supports 3 question types: target↔english, definition→target (no romanization)

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const latinIntermediateItems: VocabularyItem[] = [
  // Time & Nature (1-10)
  {
    id: 'la-int-001',
    target: 'tempus',
    english: 'time',
    definition: 'The ongoing progression of events',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-002',
    target: 'dies',
    english: 'day',
    definition: 'A period of 24 hours',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-003',
    target: 'nox',
    english: 'night',
    definition: 'The dark period between sunset and sunrise',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-004',
    target: 'annus',
    english: 'year',
    definition: 'A period of 365 days',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-005',
    target: 'sol',
    english: 'sun',
    definition: 'The star that gives light and heat',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-006',
    target: 'luna',
    english: 'moon',
    definition: 'The natural satellite orbiting Earth',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-007',
    target: 'stella',
    english: 'star',
    definition: 'A luminous point in the night sky',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-008',
    target: 'ignis',
    english: 'fire',
    definition: 'The phenomenon of combustion with light and heat',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-009',
    target: 'ventus',
    english: 'wind',
    definition: 'Moving air in the atmosphere',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-010',
    target: 'mare',
    english: 'sea',
    definition: 'A large body of salt water',
    partOfSpeech: 'noun'
  },

  // Body & Life (11-20)
  {
    id: 'la-int-011',
    target: 'corpus',
    english: 'body',
    definition: 'The physical structure of a person',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-012',
    target: 'caput',
    english: 'head',
    definition: 'The upper part of the body containing the brain',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-013',
    target: 'manus',
    english: 'hand',
    definition: 'The end part of the arm with fingers',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-014',
    target: 'oculus',
    english: 'eye',
    definition: 'The organ of sight',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-015',
    target: 'cor',
    english: 'heart',
    definition: 'The organ that pumps blood',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-016',
    target: 'vita',
    english: 'life',
    definition: 'The existence of a living being',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-017',
    target: 'mors',
    english: 'death',
    definition: 'The end of life',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-018',
    target: 'anima',
    english: 'soul / spirit',
    definition: 'The spiritual part of a person',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-019',
    target: 'mens',
    english: 'mind',
    definition: 'The thinking part of a person',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-020',
    target: 'vox',
    english: 'voice',
    definition: 'Sound produced in speaking',
    partOfSpeech: 'noun'
  },

  // Society & Places (21-30)
  {
    id: 'la-int-021',
    target: 'urbs',
    english: 'city',
    definition: 'A large urban settlement',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-022',
    target: 'rex',
    english: 'king',
    definition: 'A male ruler of a kingdom',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-023',
    target: 'regina',
    english: 'queen',
    definition: 'A female ruler of a kingdom',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-024',
    target: 'populus',
    english: 'people / nation',
    definition: 'A group of citizens',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-025',
    target: 'miles',
    english: 'soldier',
    definition: 'A person who serves in an army',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-026',
    target: 'bellum',
    english: 'war',
    definition: 'Armed conflict between nations',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-027',
    target: 'pax',
    english: 'peace',
    definition: 'Freedom from war or conflict',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-028',
    target: 'lex',
    english: 'law',
    definition: 'A rule established by authority',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-029',
    target: 'templum',
    english: 'temple',
    definition: 'A building for religious worship',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-int-030',
    target: 'forum',
    english: 'forum / marketplace',
    definition: 'A public square for commerce and discussion',
    partOfSpeech: 'noun'
  },

  // Adjectives (31-40)
  {
    id: 'la-int-031',
    target: 'magnus',
    english: 'great / large',
    definition: 'Big in size or importance',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-032',
    target: 'parvus',
    english: 'small / little',
    definition: 'Limited in size',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-033',
    target: 'bonus',
    english: 'good',
    definition: 'Having positive qualities',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-034',
    target: 'malus',
    english: 'bad / evil',
    definition: 'Having negative qualities',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-035',
    target: 'novus',
    english: 'new',
    definition: 'Recently made or discovered',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-036',
    target: 'antiquus',
    english: 'ancient / old',
    definition: 'Belonging to the distant past',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-037',
    target: 'pulcher',
    english: 'beautiful',
    definition: 'Pleasing to look at',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-038',
    target: 'fortis',
    english: 'strong / brave',
    definition: 'Having power or courage',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-039',
    target: 'felix',
    english: 'happy / fortunate',
    definition: 'Feeling or bringing good fortune',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-int-040',
    target: 'verus',
    english: 'true / real',
    definition: 'Corresponding to reality',
    partOfSpeech: 'adjective'
  },

  // More Verbs (41-50)
  {
    id: 'la-int-041',
    target: 'scire',
    english: 'to know',
    definition: 'To have knowledge of something',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-042',
    target: 'credere',
    english: 'to believe',
    definition: 'To accept as true',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-043',
    target: 'putare',
    english: 'to think',
    definition: 'To have an opinion or thought',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-044',
    target: 'petere',
    english: 'to seek / to ask',
    definition: 'To try to obtain or request',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-045',
    target: 'capere',
    english: 'to take / to capture',
    definition: 'To get hold of something',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-046',
    target: 'mittere',
    english: 'to send',
    definition: 'To cause to go to another place',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-047',
    target: 'ponere',
    english: 'to put / to place',
    definition: 'To set something in a position',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-048',
    target: 'ferre',
    english: 'to carry / to bear',
    definition: 'To transport or endure something',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-049',
    target: 'ducere',
    english: 'to lead',
    definition: 'To guide or direct others',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-int-050',
    target: 'gerere',
    english: 'to carry on / to wage',
    definition: 'To conduct or manage affairs',
    partOfSpeech: 'verb'
  }
];
